
import SmiV2BaseApi from './smiV2BaseApi';


const addAuthHeader = (u, p) => {
  return { 'Authorization': `Basic ${btoa(`${u}:${p}`)}` };
};

export default class SmiV2Instagram extends SmiV2BaseApi {
  postUser({ user, token, username, password }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}`, {
      method: 'POST',
      headers: Object.assign((username && password) ? addAuthHeader(username, password) : {}, { token }),
    });
  }

  postCode({ user, token, code, userId, nonceCode }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/code`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
      body: JSON.stringify({
        code,
        userId,
        nonceCode,
      }),
    });
  }

  postTwofa({ user, token, code }) {
    return fetch(`${this.smiv2ApiEndpoint}/v2/users/${user}/${this.serviceName}/twofa`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
      body: JSON.stringify({ code }),
    });
  }

}
